import { useEffect, useState } from "react";
import { UserType } from "../types";
import { axiosWithToken } from "../../../utils/axios";
import { getUserAPIResponseType } from "../../../features/auth/types";
import { set } from "../../../features/auth/requests";
import isUserPaid from "../../../utils/isUserPaid";

const useFetchUser = (username:string) => {
  const [user, setUser] = useState<UserType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    // 非同期の即時実行関数を定義して実行
    const fetchUser = async () => {
      try {
        const res = await axiosWithToken.get(`/users/${username}/`) as getUserAPIResponseType;
        const data = res.data as UserType;
        set('user', res.data);
        setUser(data); 
        setLoading(false); 
      } catch (error) {
        setLoading(false); 
      }
    };

    fetchUser();
  }, [username]); // username が変更された場合にのみこの効果を再実行
  return {user, loading, isPaid: isUserPaid(user)};
}

export default useFetchUser;